const FaqsList = [
    {
        question: 'How do i become a registered user?',
        answer: 'You register with your phone number and email address'
    },
    {
        question: 'How do I set a pickup request?',
        answer: 'Upload an image of the item, Give a brief description, Input pick-up address and phone number, Input destination address and phone number, and then click the request button.'
    },
    {
        question: 'How are the rates determined?',
        answer: 'Various drivers on the platform the request and respond with their individual quotes. User Compares  various driver quotes ,driver profiles and vehicle types to make a decision on who does the delivery.'
    },
    {
        question: 'Can I schedule my delivery?',
        answer: 'Yes, deliveries can be scheduled on the app.'
    },
    {
        question: 'How do I make payments?',
        answer: 'Payments can be made  via Paystack (bank transfers, card payments, USSD), and also with accumulated earnings from referrals and promotions.'
    },
    {
        question: 'Can my delivery be tracked?',
        answer: 'Yes, deliveries can be tracked on the app.'
    },
    {
        question: 'Am I required to make any extra payments?',
        answer: 'No extra payment is required.'
    }
]

export default FaqsList;